import { render } from "./LoginPc.vue?vue&type=template&id=19ab2da7&ts=true"
import script from "./LoginPc.vue?vue&type=script&lang=ts"
export * from "./LoginPc.vue?vue&type=script&lang=ts"

import "./LoginPc.vue?vue&type=style&index=0&id=19ab2da7&lang=less"

import exportComponent from "/www/wwwroot/login.mobro.cc/login/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__